import _compact from 'lodash/compact';
import _isEmpty from 'lodash/isEmpty';
import _map from 'lodash/map';

import { localeTypes } from '../locales';

type actionType = 'twitter' | 'line' | 'facebook';

const externalLinks = {
  twitter: 'https://twitter.com/intent/tweet?text=${text}',
  line: 'https://line.me/R/msg/text/?${text}',
  facebook: 'https://www.facebook.com/sharer/sharer.php?u=${text}',
};

const getQueries = (params: Record<string, string | undefined>) => {
  return _compact(
    _map(params, (v, k) => {
      if (!v) {
        return null;
      }
      return `${k}=${encodeURIComponent(v)}`;
    }),
  );
};

const createExternalUrl = (type: actionType, text: string): string => {
  const link = externalLinks[type];
  return link.replace('${text}', encodeURIComponent(text));
};

const createInternalLink = (
  path: string,
  params: Record<string, string | undefined>,
): string => {
  const { protocol, host } = location;
  const queries = getQueries(params);
  const url = `${protocol}//${host}${path}`;
  return _isEmpty(queries) ? url : `${url}?${queries.join('&')}`;
};

const getLocalePath = (path: string, locale: string): string => {
  const prefix = locale === localeTypes.Japanese ? '' : `/${locale}`;
  return `${prefix}${path}`;
};

export { createExternalUrl, createInternalLink, getLocalePath };
